module.exports = "/img/40.b7d799.webp";